module.exports = __webpack_public_path__ + "media/src/images/step04-3663c3ce421ebf22e5e12ec94d77f429.png";